function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRacing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 441.103 441.103",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88928F"
    },
    d: "M415.372,220.556c0-114.703-92.984-207.686-207.687-207.686C92.98,12.87,0,105.854,0,220.556 c0,114.693,92.98,207.676,207.685,207.676C322.387,428.233,415.372,335.249,415.372,220.556z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "149.289,199.128 106.962,231.422 151.241,231.422 193.568,199.128  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "45.252,199.128 2.925,231.422 27.872,231.422 70.199,199.128  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "396.027,199.128 353.7,231.422 397.978,231.422 440.305,199.128  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "272.66,199.128 230.333,231.422 274.609,231.422 316.936,199.128  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 265.343,
    y: 169.591,
    transform: "matrix(0.9672 0.2539 -0.2539 0.9672 80.0531 -77.8337)",
    style: {
      fill: "#F5ECE1"
    },
    width: 152.452,
    height: 203.266
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.36,
    y: 159.188,
    transform: "matrix(0.9672 0.2539 -0.2539 0.9672 57.091 -73.1143)",
    style: {
      fill: "#505B66"
    },
    width: 50.817,
    height: 50.818
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.666,
    y: 184.99,
    transform: "matrix(0.9672 0.2538 -0.2538 0.9672 66.84 -97.2028)",
    style: {
      fill: "#505B66"
    },
    width: 50.816,
    height: 50.817
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.611,
    y: 221.244,
    transform: "matrix(0.9672 0.2539 -0.2539 0.9672 74.0252 -80.277)",
    style: {
      fill: "#505B66"
    },
    width: 50.819,
    height: 50.809
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.556,
    y: 257.489,
    transform: "matrix(0.9672 0.2539 -0.2539 0.9672 81.1878 -63.3301)",
    style: {
      fill: "#505B66"
    },
    width: 50.818,
    height: 50.816
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.863,
    y: 283.288,
    transform: "matrix(0.9672 0.2538 -0.2538 0.9672 90.9433 -87.4304)",
    style: {
      fill: "#505B66"
    },
    width: 50.818,
    height: 50.819
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.808,
    y: 319.541,
    transform: "matrix(0.9672 0.2539 -0.2539 0.9672 98.1438 -70.5084)",
    style: {
      fill: "#505B66"
    },
    width: 50.82,
    height: 50.817
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 265.343,
    y: 169.591,
    transform: "matrix(0.9672 0.2539 -0.2539 0.9672 80.0531 -77.8337)",
    style: {
      fill: "#F5ECE1"
    },
    width: 152.452,
    height: 203.266
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.36,
    y: 159.188,
    transform: "matrix(0.9672 0.2539 -0.2539 0.9672 57.091 -73.1143)",
    style: {
      fill: "#505B66"
    },
    width: 50.817,
    height: 50.818
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.666,
    y: 184.99,
    transform: "matrix(0.9672 0.2538 -0.2538 0.9672 66.84 -97.2028)",
    style: {
      fill: "#505B66"
    },
    width: 50.816,
    height: 50.817
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.611,
    y: 221.244,
    transform: "matrix(0.9672 0.2539 -0.2539 0.9672 74.0252 -80.277)",
    style: {
      fill: "#505B66"
    },
    width: 50.819,
    height: 50.809
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.556,
    y: 257.489,
    transform: "matrix(0.9672 0.2539 -0.2539 0.9672 81.1878 -63.3301)",
    style: {
      fill: "#505B66"
    },
    width: 50.818,
    height: 50.816
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.863,
    y: 283.288,
    transform: "matrix(0.9672 0.2538 -0.2538 0.9672 90.9433 -87.4304)",
    style: {
      fill: "#505B66"
    },
    width: 50.818,
    height: 50.819
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.808,
    y: 319.541,
    transform: "matrix(0.9672 0.2539 -0.2539 0.9672 98.1438 -70.5084)",
    style: {
      fill: "#505B66"
    },
    width: 50.82,
    height: 50.817
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#505B66"
    },
    points: "242.038,350.174 272.1,235.644 360.947,337.766  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.62,
      fill: "#505B66"
    },
    points: "242.038,350.174 272.1,235.644 360.947,337.766  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 136.822,
    y: 105.578,
    transform: "matrix(0.9672 0.2539 -0.2539 0.9672 61.2503 -60.2002)",
    style: {
      fill: "#F5ECE1"
    },
    width: 254.089,
    height: 203.265
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.505,
    y: 82.273,
    transform: "matrix(0.9672 0.2539 -0.2539 0.9672 33.3925 -43.4135)",
    style: {
      fill: "#505B66"
    },
    width: 50.818,
    height: 50.818
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.811,
    y: 108.076,
    transform: "matrix(0.9672 0.2539 -0.2539 0.9672 43.1658 -67.5267)",
    style: {
      fill: "#505B66"
    },
    width: 50.819,
    height: 50.819
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.117,
    y: 133.88,
    transform: "matrix(0.9672 0.2539 -0.2539 0.9672 52.9421 -91.6447)",
    style: {
      fill: "#505B66"
    },
    width: 50.82,
    height: 50.819
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.756,
    y: 144.327,
    transform: "matrix(0.9672 0.2539 -0.2539 0.9672 50.3471 -50.5942)",
    style: {
      fill: "#505B66"
    },
    width: 50.818,
    height: 50.819
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.062,
    y: 170.13,
    transform: "matrix(0.9672 0.2538 -0.2538 0.9672 60.1004 -74.6906)",
    style: {
      fill: "#505B66"
    },
    width: 50.818,
    height: 50.819
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.702,
    y: 180.577,
    transform: "matrix(0.9672 0.2538 -0.2538 0.9672 57.4974 -33.6411)",
    style: {
      fill: "#505B66"
    },
    width: 50.818,
    height: 50.819
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.007,
    y: 206.382,
    transform: "matrix(0.9673 0.2538 -0.2538 0.9673 67.2605 -57.7452)",
    style: {
      fill: "#505B66"
    },
    width: 50.817,
    height: 50.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.313,
    y: 232.184,
    transform: "matrix(0.9672 0.2539 -0.2539 0.9672 77.0503 -81.8695)",
    style: {
      fill: "#505B66"
    },
    width: 50.817,
    height: 50.812
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.953,
    y: 242.631,
    transform: "matrix(0.9672 0.2539 -0.2539 0.9672 74.4413 -40.8129)",
    style: {
      fill: "#505B66"
    },
    width: 50.818,
    height: 50.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.259,
    y: 268.431,
    transform: "matrix(0.9672 0.2539 -0.2539 0.9672 84.2369 -64.9375)",
    style: {
      fill: "#505B66"
    },
    width: 50.817,
    height: 50.817
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EA7053"
    },
    d: "M181.184,46.976L141.617,36.59c-6.489-1.705-13.128,2.176-14.83,8.665 c-1.704,6.485,2.176,13.126,8.663,14.83l6.182,1.623L61.275,367.842c7.39,7.344,15.331,14.131,23.752,20.303l83.809-319.299 l6.184,1.624c6.487,1.701,13.128-2.177,14.83-8.664C191.553,55.318,187.674,48.678,181.184,46.976z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 136.822,
    y: 105.578,
    transform: "matrix(0.9672 0.2539 -0.2539 0.9672 61.2503 -60.2002)",
    style: {
      fill: "#F5ECE1"
    },
    width: 254.089,
    height: 203.265
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.505,
    y: 82.273,
    transform: "matrix(0.9672 0.2539 -0.2539 0.9672 33.3925 -43.4135)",
    style: {
      fill: "#505B66"
    },
    width: 50.818,
    height: 50.818
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.811,
    y: 108.076,
    transform: "matrix(0.9672 0.2539 -0.2539 0.9672 43.1658 -67.5267)",
    style: {
      fill: "#505B66"
    },
    width: 50.819,
    height: 50.819
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.117,
    y: 133.88,
    transform: "matrix(0.9672 0.2539 -0.2539 0.9672 52.9421 -91.6447)",
    style: {
      fill: "#505B66"
    },
    width: 50.82,
    height: 50.819
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.756,
    y: 144.327,
    transform: "matrix(0.9672 0.2539 -0.2539 0.9672 50.3471 -50.5942)",
    style: {
      fill: "#505B66"
    },
    width: 50.818,
    height: 50.819
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.062,
    y: 170.13,
    transform: "matrix(0.9672 0.2538 -0.2538 0.9672 60.1004 -74.6906)",
    style: {
      fill: "#505B66"
    },
    width: 50.818,
    height: 50.819
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.702,
    y: 180.577,
    transform: "matrix(0.9672 0.2538 -0.2538 0.9672 57.4974 -33.6411)",
    style: {
      fill: "#505B66"
    },
    width: 50.818,
    height: 50.819
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.007,
    y: 206.382,
    transform: "matrix(0.9673 0.2538 -0.2538 0.9673 67.2605 -57.7452)",
    style: {
      fill: "#505B66"
    },
    width: 50.817,
    height: 50.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.313,
    y: 232.184,
    transform: "matrix(0.9672 0.2539 -0.2539 0.9672 77.0503 -81.8695)",
    style: {
      fill: "#505B66"
    },
    width: 50.817,
    height: 50.812
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.953,
    y: 242.631,
    transform: "matrix(0.9672 0.2539 -0.2539 0.9672 74.4413 -40.8129)",
    style: {
      fill: "#505B66"
    },
    width: 50.818,
    height: 50.813
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#505B66"
    },
    points: "311.97,325.115 262.965,312.195 275.543,262.812 324.695,275.713  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRacing);
export default __webpack_public_path__ + "static/media/racing.83dc304fb6708a835cc340746c50ea34.svg";
export { ForwardRef as ReactComponent };